import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AgeSelect from '../../components/Selects/AgeSelect/AgeSelect';
import { actions as agingActions } from '../../reducers/modules/aging/aging';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class Aging extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    aging: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      aging: PropTypes.object,
      ageToDate: PropTypes.any,
      defaultAgingDate: PropTypes.any,
      benchmarkYear: PropTypes.number,
      dynamicAgingEnabled: PropTypes.bool,
      cacheUpdated: PropTypes.bool
    }),
    userReportViewer: PropTypes.bool,
    location: PropTypes.object,
    className: PropTypes.string
  };
  constructor(props) {
    super(props);
    this.setJobAgeToDate = this.setJobAgeToDate.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props === nextProps) return;
    // only really update the aging cache if the user might've updated
    // the aging on the pricing page
    if (
      this.props.location.pathname !== nextProps.location.pathname &&
      this.props.location.pathname.indexOf('pricing2') >= 0
    ) {
      agingActions.updateAging(this.props.dispatch);
    }
  }
  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps;
  }
  componentDidMount() {
    agingActions.getAging(this.props.dispatch);
  }
  setJobAgeToDate(data) {
    return agingActions.setAgeToDate(this.props.dispatch, data.ageToDate);
    
  }
  render() {
    if (
      !this.props.aging.dynamicAgingEnabled ||
      this.props.location.pathname.indexOf('pricing2') >= 0 ||
      this.props.userReportViewer
    ) {
      return null;
    }
    if (this.props.aging.loading || !this.props.aging.loaded) {
      return <div>loading...</div>;
    }
    return (
      <AgeSelect
        ageToDate={this.props.aging.ageToDate}
        defaultAgingDate={this.props.aging.defaultAgingDate}
        setAgeToDateHandler={this.setJobAgeToDate}
        benchmarkYear={this.props.aging.benchmarkYear}
        className={this.props.className}
        getShowOverlay={this?.props?.getShowOverlay}
      />
    );
  }
}
const mapStateToProps = ({ aging, session }) => {
  return {
    aging,
    userReportViewer: session.user.rights.reportViewUser
  };
};

export default withRouter(connect(mapStateToProps)(Aging));
